import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { NewFilterLabel } from '@spa/shared/components/Labels';
import { GroupHeader, GroupContainer } from './styles';

const Group = ({ title, children, isNew = false, hasTitle = true }) => {
  const { t } = useTranslation('translations');

  return (
    <GroupContainer aria-labelledby={title} tabIndex="0">
      <GroupHeader>
        {hasTitle && <span>{title}</span>}
        {isNew && <NewFilterLabel> {t('global.labels.new')} </NewFilterLabel>}
      </GroupHeader>
      {children}
    </GroupContainer>
  );
};

Group.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  isNew: PropTypes.bool,
  hasTitle: PropTypes.bool
};

export default Group;
